import {HeaderInfoTypes} from './HeaderPageInfo.types';

const content: HeaderInfoTypes = {
  title: '13337337',
  value: '???',
  percent: '???',
  id: 1,
};

export {content};
